'use client';

import { AuthenticationStatus } from '@/enums/authentication-status';
import { useSession } from 'next-auth/react';
import { useSharedState } from '../state/shared-state';

type IsAuthReady = {
  isAuthenticated: boolean;
  isLoading: boolean;
};

export const useIsAuthReady = (): IsAuthReady => {
  const { data: session, status } = useSession();
  const { data: sharedState, isLoading: isSharedStateLoading } = useSharedState();

  return {
    isAuthenticated: status === AuthenticationStatus.AUTHENTICATED && !!session?.keycloakId && !!sharedState?.isAuthenticated,
    isLoading: status === AuthenticationStatus.LOADING || isSharedStateLoading,
  };
};
